export default "__VITE_ASSET__DIGTzns9__"